// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
import { gtmEventPush } from 'utils/gtm/events';

// Components

import Carousel from '../Carousel';
import Picture from '../Picture';
import { connect } from 'react-redux';
import * as Actions from 'actionTypes';
import getResizedImage from 'utils/getResizedImage';

// Helpers

/**
 * Gallery React component.
 */
class Gallery extends PureComponent<*, *> {
  itemsLength: number;
  /**
   *  Props implementation.
   */
  static propTypes = {
    children: PropTypes.array,
    pictures: PropTypes.array.isRequired,
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    activeItemIndex: PropTypes.number,
    openModal: PropTypes.func,
    onChange: PropTypes.func,
    viewport: PropTypes.string
  };

  /**
   * Props implementation.
   * @param {object} props - component props
   */
  constructor(props: Object) {
    super(props);
    this.itemsLength = this.props.pictures ? this.props.pictures.length : 0;

    this.state = {
      activeItemIndex: 0
    };
  }

  /* eslint-disable camelcase */
  /**
   * UNSAFE_componentWillReceiveProps implementation.
   * @param {object} nextProps object
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.pictures !== nextProps.pictures) {
      this.itemsLength = nextProps.pictures ? nextProps.pictures.length : 0;
      // Reset activeIndex.
      this.setState({
        activeItemIndex: 0
      });
    }
  }

  /**
   * MapStateToProps implementation.
   * @return {object} new state object
   * @param {object} state object
   */
  static mapStateToProps(state: Object) {
    return {
      viewport: state.viewport.viewport
    };
  }

  /**
   * mapDispatchToProps implementation.
   * @return {object} mapped dispatch
   * @param {object} dispatch object
   */
  static mapDispatchToProps(dispatch) {
    return {
      openModal: () => {
        gtmEventPush({
          method: 'gallery',
          args: {
            itemLabel: 'Open modal'
          }
        }); // $FlowFixMe
        document.body.style.overflow = 'hidden';
        dispatch({ type: Actions.OPEN_MODAL });
      }
    };
  }

  /**
   * navigates to new slide
   * @param {string} direction - previous or next
   * @return {void}
   */
  handleNavigate = (direction: string) => {
    const { activeItemIndex } = this.state;
    let newIndex = 0;
    if (direction === 'previous') {
      newIndex = activeItemIndex - 1 === -1 ? 0 : activeItemIndex - 1;
    } else {
      newIndex =
        activeItemIndex + 1 === this.itemsLength
          ? this.itemsLength
          : activeItemIndex + 1;
    }
    this.setState({ activeItemIndex: newIndex });
    if (this.props.onChange) {
      this.props.onChange();
    }
  };

  /**
   * navigates to new slide
   * @param {string} index - previous or next
   * @return {void}
   */
  handleOnClick = index => {
    this.setState({ activeItemIndex: index });
    if (this.props.onChange) {
      this.props.onChange();
    }
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> | null {
    const { pictures, openModal, viewport, ...otherProps } = this.props;

    const { activeItemIndex } = this.state;

    const isSmallDevice = viewport === 'xs' || viewport === 'sm' || false;
    const picturesToRender = pictures.length
      ? pictures
      : [
          {
            alt: 'myAlt',
            title: 'myTitle',
            image: {
              lg: `${process.env.PUBLIC_URL || ''}/images/fallback.png`
            }
          }
        ];
    return picturesToRender ? (
      <div>
        <Carousel
          {...otherProps}
          itemsToDisplay={1}
          showSlider={(!isSmallDevice && pictures.length > 1) || true}
          showPagination={false}
          activeItemIndex={activeItemIndex}
          pictures={picturesToRender}
          handleNext={this.handleNavigate}
          handlePrevious={this.handleNavigate}
          openModal={
            isSmallDevice || picturesToRender.length <= 1 ? null : openModal
          }
          viewport={viewport}
          gtmSectionName={'gallery'}
        >
          {picturesToRender &&
            picturesToRender.map((picture, key) => (
              <Picture
                pictures={getResizedImage(
                  picture,
                  viewport,
                  'GalleryMainImage'
                )}
                key={key}
                caption={'This is caption' + key}
              />
            ))}
        </Carousel>
        {!isSmallDevice && picturesToRender.length > 1 && (
          <Carousel
            {...otherProps}
            itemsToDisplay={5}
            showSlider={true}
            showCaption={false}
            activeItemIndex={Math.floor(activeItemIndex / 5)}
            pictures={picturesToRender}
            handleOnClick={this.handleOnClick}
            activeThumb={activeItemIndex}
            carouselType={'paginationThumb'}
            gtmSectionName={'gallery'}
          >
            {picturesToRender &&
              picturesToRender.map((picture, key) => (
                <Picture
                  pictures={getResizedImage(picture, viewport, 'GalleryThumb')}
                  key={key}
                  caption={'This is caption' + key}
                />
              ))}
          </Carousel>
        )}
      </div>
    ) : null;
  }
}

// $FlowFixMe
export default connect(
  Gallery.mapStateToProps,
  Gallery.mapDispatchToProps
)(Gallery);



// WEBPACK FOOTER //
// ./src/Common/Gallery/index.js